<h2 mat-dialog-title>
  {{ data.mode === 'validation' ? 'Validation Errors' : 'Select Status' }}
</h2>

<mat-dialog-content>

  <!-- VALIDATION MODE -->
  <ng-container *ngIf="data.mode === 'validation'">
    <ul>
      <li *ngFor="let error of data.errors">
        <strong>{{ error.component }}</strong>
        <span *ngIf="error.field"> ({{ error.field }})</span>
        : {{ error.message }}
      </li>
    </ul>
  </ng-container>

  <!-- STATUS MODE -->
  <ng-container *ngIf="data.mode === 'status'">
    <mat-form-field appearance="outline" style="width:100%; padding: 1rem;">
      <mat-label>Select Status</mat-label>
      <mat-select [(value)]="selectedStatus">
        <mat-option *ngFor="let option of data.statusOptions"
                    [value]="option.value">
          {{ option.displayName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ng-container>

</mat-dialog-content>

<mat-dialog-actions align="end">
  
  		     <app-common-button
          label="Back"
          title="Back "  
          [buttonId]="1111"
          variant="cancel"
          width="110px"
          [critical]="false"
          (clicked)="close()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
  <!-- <button mat-raised-button color="primary"
          (click)="confirm()"
          [disabled]="data.mode === 'status' && !selectedStatus">
    Confirm
  </button> -->
  		  <app-common-button
          label="Confirm"
          title="Confirm "

          [buttonId]="1111"
			width="110px"
          [critical]="false"
          (clicked)="confirm()"
           style="margin-left: 6px;margin-right:6px;"
            [disabled]="data.mode === 'status' && !selectedStatus"
          >
          </app-common-button>
</mat-dialog-actions>